import { useState } from 'react'
import type { IntakeDomain } from '../../orders/api/intakeApi'
import { FieldBuilder } from './FieldBuilder'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../../components/ui/tabs'

interface DomainFieldBuilderProps {
  merchantId: string
  solutionId: string
  /** Optionally restrict which domains to show (defaults to all 3) */
  domains?: IntakeDomain[]
}

const ALL_DOMAINS: IntakeDomain[] = ['BOOKING', 'CUSTOM_ORDER', 'PACKAGE']
const DOMAIN_LABELS: Record<IntakeDomain, string> = {
  BOOKING: 'Booking',
  CUSTOM_ORDER: 'Custom Order',
  PACKAGE: 'Package',
}

export function DomainFieldBuilder({
  merchantId,
  solutionId,
  domains = ALL_DOMAINS,
}: DomainFieldBuilderProps) {
  const [activeTab, setActiveTab] = useState<IntakeDomain>(domains[0])

  return (
    <Tabs value={activeTab} onValueChange={(v) => setActiveTab(v as IntakeDomain)}>
      <TabsList className="mb-4">
        {domains.map((d) => (
          <TabsTrigger key={d} value={d}>
            {DOMAIN_LABELS[d]}
          </TabsTrigger>
        ))}
      </TabsList>

      {domains.map((d) => (
        <TabsContent key={d} value={d}>
          <FieldBuilder merchantId={merchantId} solutionId={solutionId} domain={d} />
        </TabsContent>
      ))}
    </Tabs>
  )
}
